module.exports = __webpack_public_path__ + "static/media/north-arrow.0db7082f.png";